import {
  StyleCard,
  StyleLeftBannerWrapper,
  StyleRightBannerWrapper,
} from './style'
import Image from '@components/image'
import Typography from '@components/typography'
import Button from '@components/button'
import BannerImg from './banner.png'
import Svg from '@components/svg'
const Banner = () => {
  return (
    <StyleCard>
      <StyleLeftBannerWrapper>
        <Typography
          content={`Create a Lab Test Appointment`}
          tc="primary"
          weight={500}
          size={18}
        />
        <Typography
          content={`Easily schedule lab tests for your patients. Enter details, choose a test type, and manage appointments all in one place.`}
          tc="text"
          weight={500}
          size={18}
        />
        <Button
          leftComponent={<Svg svg="circlePlus" color={'white'} />}
          title="Add New Lab Test Appointment"
          height={45}
          styleButtonWrapper="margin-top:10px;"
        />
      </StyleLeftBannerWrapper>
      <StyleRightBannerWrapper>
        <Image src={BannerImg} height={200} />
      </StyleRightBannerWrapper>
    </StyleCard>
  )
}

export default Banner
